/* import __COLOCATED_TEMPLATE__ from './preload-plan-selection-hero-picture.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();